export const mediaErrorCodeToMessageMapping: Record<
  MediaError['code'],
  string
> = {
  1: 'Media fetch aborted by user',
  2: 'Network error',
  3: 'Media decoding error',
  4: 'Media source not supported',
};
